import React, { useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import styles from "./date.css";
import moment from "moment-jalaali";

const DatePickerCustom = ({
  placeholder,
  onChange,
  value,
  name,
  defaultValue,
}) => {
  const handleDate = (e) => {
    onChange(moment.unix(e.unix).format("YYYY/MM/DD"));
  };
  const [label, setLabel] = useState(false);

  useEffect(() => {
    if (defaultValue) setLabel(true);
  }, [value]);
  console.log(value);
  return (
    <>
      <div id={name} className={"customDate"} style={{ direction: "lrt" }}>
        <DatePicker
          value={value ? value : defaultValue ? defaultValue : false}
          calendar={persian}
          format={"YYYY/MM/DD"}
          locale={persian_fa}
          placeholder={placeholder}
          calendarPosition="bottom-right"
          onChange={(e) => {
            handleDate(e);
            setLabel(true);
          }}
        />
        <label className={`${label ? "labelShow" : ""}`}>{placeholder}</label>
      </div>
    </>
  );
};

export default DatePickerCustom;
